import { put, takeLatest } from 'redux-saga/effects';
import instance from 'src/sagas/set';
import { ReviewActionCreators } from 'src/store/reducers/feedback/action-creators';
import { ReviewActionEnum } from 'src/store/reducers/feedback/types';

function* fetchAddReview({ data }: ReturnType<typeof ReviewActionCreators.addReview>) {
  try {
    const { status }: Response = yield instance.post('feedback', {
      data: [data]
    });
    yield put(ReviewActionCreators.resultAddReview(status));
  } catch (e) {
    console.log(e);
  }
}

export function* actionWatcherAddReview() {
  yield takeLatest(ReviewActionEnum.REQUEST_ADD_REVIEW, fetchAddReview);
}
